var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2H4C2.89543 2 2 2.89543 2 4V11C2 12.1046 2.89543 13 4 13H9C10.1046 13 11 12.1046 11 11V4C11 2.89543 10.1046 2 9 2Z",
    fill: "#00685F",
    stroke: "#00685F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2H15C13.8954 2 13 2.89543 13 4V7C13 8.10457 13.8954 9 15 9H20C21.1046 9 22 8.10457 22 7V4C22 2.89543 21.1046 2 20 2Z",
    fill: "#00685F",
    stroke: "#00685F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H4C2.89543 15 2 15.8954 2 17V20C2 21.1046 2.89543 22 4 22H9C10.1046 22 11 21.1046 11 20V17C11 15.8954 10.1046 15 9 15Z",
    fill: "#00685F",
    stroke: "#00685F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11H15C13.8954 11 13 11.8954 13 13V20C13 21.1046 13.8954 22 15 22H20C21.1046 22 22 21.1046 22 20V13C22 11.8954 21.1046 11 20 11Z",
    fill: "#00685F",
    stroke: "#00685F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardactive);
export default __webpack_public_path__ + "static/media/dashboardactive.6fc3784159317da94ecf4a31034ca247.svg";
export { ForwardRef as ReactComponent };